module.exports = __webpack_public_path__ + "img/facebook.e9dacd4b.svg";